<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">1. 基本信息</div>
        </div>
        <!-- PC端表格布局 -->
        <table width="100%" class="Table pc-only">
            <tbody>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>姓名</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGeRenData.name" ></el-input></td>
                    <td width="10%"><span class="Red">*</span>手机号</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGeRenData.mobile" ></el-input></td>
                    <td width="10%"><span class="Red">*</span>单位名称</td>
                    <td width="23%">
                        <el-autocomplete
                            class="WidMax"
                            size="small"
                            v-model="SetGeRenData.nation"
                            :fetch-suggestions="queryHospitals"
                            placeholder="请输入单位名称"
                            :trigger-on-focus="false"
                            @select="handleHospitalSelect">
                        </el-autocomplete>
                    </td>
                </tr>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>单位等级</td>
                    <td colspan="5">
                        <el-radio-group v-model="SetGeRenData.gender">
                            <el-radio 
                                v-for="item in hosLevelList" 
                                :key="item.dictCode" 
                                :label="item.dictValue">
                                {{ item.dictLabel }}
                            </el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>地区</td>
                    <td width="23%">
                        <el-cascader
                            size="small"
                            class="WidMax"
                            v-model="SetGeRenData.region"
                            :options="regionOptions"
                            :props="{ value: 'value', label: 'label', children: 'children', expandTrigger: 'hover' }"
                            placeholder="请选择省/市/区"
                            @change="handleRegionChange"
                            clearable
                        ></el-cascader>
                    </td>
                    <td width="10%"><span class="Red">*</span>科室/部门</td>
                    <td width="23%"><el-input size="small" placeholder="请输入科室/部门" v-model="SetGeRenData.workPhone" ></el-input></td>
                    <td width="10%"><span class="Red">*</span>职务</td>
                    <td width="23%"><el-input size="small" placeholder="请输入职务" v-model="SetGeRenData.work_title" ></el-input></td>       
                </tr>
                <tr v-if="TypeId==1">
                    <td><span class="Red">*</span>职称</td>
                    <td width="23%">
                        <el-select 
                            size="small" 
                            class="WidMax" 
                            placeholder="请选择职称" 
                            v-model="SetGeRenData.grade">
                            <el-option 
                                v-for="item in zhichengList" 
                                :key="item.dictCode" 
                                :label="item.dictLabel" 
                                :value="item.dictValue"
                                :disabled="item.status === '1'">
                            </el-option>
                        </el-select>
                    </td>
                    <td width="10%"><span class="Red">*</span>邮箱账号</td>
                    <td width="23%"><el-input size="small" placeholder="请输入邮箱账号" v-model="SetGeRenData.userEmail" ></el-input></td>
                </tr>
            </tbody>
        </table>
        
        <!-- 移动端表单布局 -->
        <div class="mobile-form mobile-only" v-if="TypeId==1">
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>姓名</div>
                <div class="form-input">
                    <el-input size="small" placeholder="请输入" v-model="SetGeRenData.name"></el-input>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>手机号</div>
                <div class="form-input">
                    <el-input size="small" placeholder="请输入" v-model="SetGeRenData.mobile"></el-input>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>单位名称</div>
                <div class="form-input">
                    <el-autocomplete
                        class="WidMax"
                        size="small"
                        v-model="SetGeRenData.nation"
                        :fetch-suggestions="queryHospitals"
                        placeholder="请输入单位名称"
                        :trigger-on-focus="false"
                        @select="handleHospitalSelect">
                    </el-autocomplete>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>单位等级</div>
                <div class="form-input radio-group">
                    <el-radio-group v-model="SetGeRenData.gender">
                        <el-radio 
                            v-for="item in hosLevelList" 
                            :key="item.dictCode" 
                            :label="item.dictValue"
                            class="mobile-radio">
                            {{ item.dictLabel }}
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>地区</div>
                <div class="form-input">
                    <el-cascader
                        size="small"
                        class="WidMax"
                        v-model="SetGeRenData.region"
                        :options="regionOptions"
                        :props="{ value: 'value', label: 'label', children: 'children', expandTrigger: 'hover' }"
                        placeholder="请选择省/市/区"
                        @change="handleRegionChange"
                        clearable
                    ></el-cascader>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>科室/部门</div>
                <div class="form-input">
                    <el-input size="small" placeholder="请输入科室/部门" v-model="SetGeRenData.workPhone"></el-input>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>职务</div>
                <div class="form-input">
                    <el-input size="small" placeholder="请输入职务" v-model="SetGeRenData.work_title"></el-input>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>职称</div>
                <div class="form-input">
                    <el-select 
                        size="small" 
                        class="WidMax" 
                        placeholder="请选择职称" 
                        v-model="SetGeRenData.grade">
                        <el-option 
                            v-for="item in zhichengList" 
                            :key="item.dictCode" 
                            :label="item.dictLabel" 
                            :value="item.dictValue"
                            :disabled="item.status === '1'">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div class="form-item">
                <div class="form-label"><span class="Red">*</span>邮箱账号</div>
                <div class="form-input">
                    <el-input size="small" placeholder="请输入邮箱账号" v-model="SetGeRenData.userEmail"></el-input>
                </div>
            </div>
        </div>
        
        <div class="info-save">注：您所填信息系统会实时保存，请您填写您的最新信息</div>
        <div class="StepBtns">
            <div class="StepBtn" @click="ToggleStep" :class="{StpepDisabled:ConfigDisabled}">下一步</div>
        </div>
    </div>
</template>

<script>
    import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'
    import { regionData } from 'element-china-area-data'

    export default {
        inject: ['worksInfo', 'isEdit', 'isLoggedIn'],
        props: {
            Type: [String, Number],
            PageDisabled: Boolean,
            initialData: {
                type: Object,
                default: () => null
            }
        },
        data() {
            return {
                isDraftMode: false, // 草稿模式标志
                loading: false,
                provinceData: [],
                hosLevelList: [],
                zhichengList: [],
                ID: "",
                ConfigDisabled: false,
                TypeId: 1,
                hospitals: [],
                SetData:{
                    name:"",
                    City:[],
                    synopsis:"",
                    address:"",
                },
                SetGeRenData:{
                    name: '',
                    grade: '',
                    gender: '',
                    mobile: '',
                    is_public: '',
                    work_mobile: '',
                    native_place: [],
                    nation: '',
                    userEmail: '',
                    political_party: '',
                    degree: '',
                    qualification: '',
                    major: '',
                    work_title: '',
                    pf_work: '',
                    workPhone: '',
                    marriage: '',
                    religion: '',
                    region: [],
                },
                SetGongSiData:{
                    legal_person:"",
                    legal_license:"",
                    link_name:"",
                    link_mobile:"",
                    link_email:"",
                    institutions:"",
                    business_field:"",
                    mechanism_website:"",
                    mechanism_wnumber:"",
                    social_institution:"",
                },
                // TypeData:[],
                MingZuData:"",
                CityData:[],
                regionOptions: regionData,
                hospitalList: [],
                isMobile: false,
                isEditMode: false,
                lastSubmittedInfo: null // 存储用户最后一次提交作品的信息
            }
        },
        created() {
            // 检测设备类型
            this.checkDeviceType();
            // 监听窗口大小变化
            window.addEventListener('resize', this.checkDeviceType);
            // 检查是否为编辑模式
            this.isEditMode = this.isEdit && this.isEdit();
        },
        beforeDestroy() {
            // 移除窗口大小变化监听器
            window.removeEventListener('resize', this.checkDeviceType);
            
            // 检查是否从成功提交页面返回
            const isFromSuccess = this.$route.query.fromSuccess === 'true';
            
            // 如果是从成功提交页面返回，不恢复缓存数据
            if (isFromSuccess) {
                // 清除缓存
                localStorage.removeItem('basicInfoData');
                return;
            }
        },
        mounted() {
            this.checkLoginStatus();
            
            if (this.isLoggedIn()) {
                this.TypeId = this.$route.query.type || this.Type;
                this.ConfigDisabled = this.PageDisabled;
                this.getHosLevelList();
                this.getZhichengList();
            }

            this.ID = this.id || '';
            this.ConfigDisabled = this.PageDisabled;

            // 检查是否从成功提交页面返回
            const isFromSuccess = this.$route.query.fromSuccess === 'true';
            
            // 如果是从成功提交页面返回，不恢复缓存数据
            if (isFromSuccess) {
                // 清除缓存
                localStorage.removeItem('basicInfoData');
                return;
            }
            
            // 检查是否是草稿模式
            const isDraft = localStorage.getItem('isDraft') === 'true';
            const draftId = this.$route.query.draftId;
            
            // 如果是草稿模式，设置一个标志位并加载草稿数据
            if (isDraft && draftId) {
                this.isDraftMode = true;
                
                try {
                    const draftDataStr = localStorage.getItem('draftData');
                    if (draftDataStr) {
                        const draftData = JSON.parse(draftDataStr);
                        
                        // 处理时间格式
                        let workTime = draftData.workTime;
                        if (workTime && workTime.includes('T')) {
                            workTime = workTime.split('T')[0];
                        }
                        
                        // 填充基本信息表单
                        this.SetGeRenData = {
                            ...this.SetGeRenData,
                            name: draftData.userName || '',
                            mobile: draftData.userPhone || '',
                            nation: draftData.userUnit || '',
                            gender: String(draftData.userUnitLevel) || '',
                            workPhone: draftData.userDept || '',
                            work_title: draftData.userZhiwu || '',
                            grade: String(draftData.userZhicheng) || '',
                            userEmail: draftData.userEmail || '', 
                            pf_work: draftData.userArea || draftData.address || ''
                        };
                        
                        // 处理地区信息
                        if (draftData.userRegion && draftData.userRegion.length > 0) {
                            // 如果是汉字形式的地区名称
                            this.SetGeRenData.region = draftData.userRegion;
                            this.SetGeRenData.selectedRegionLabels = [...draftData.userRegion];
                            this.manuallySetCascaderValue(draftData.userRegion);
                        } else if (draftData.address) {
                            // 尝试从address中提取区域信息
                            const areas = draftData.address.split(' ');
                            if (areas.length > 0) {
                                this.SetGeRenData.region = areas;
                                this.SetGeRenData.selectedRegionLabels = [...areas];
                                this.manuallySetCascaderValue(areas);
                            }
                        } else if (draftData.userArea) {
                            // 尝试从userArea中提取区域信息
                            const areas = draftData.userArea.split(' ');
                            if (areas.length > 0) {
                                this.SetGeRenData.region = areas;
                                this.SetGeRenData.selectedRegionLabels = [...areas];
                                this.manuallySetCascaderValue(areas);
                            }
                        }
                        
                        return; // 草稿模式下不需要进一步处理
                    } else {
                        console.error('未找到草稿数据');
                    }
                } catch (error) {
                    console.error('解析草稿数据失败:', error);
                }
            }

            // 如果是编辑模式
            if (this.isEdit && this.isEdit()) {
                const info = this.worksInfo && this.worksInfo();
                if (info) {
                    this.SetGeRenData = {
                        ...this.SetGeRenData,
                        name: info.userName || '',
                        mobile: info.userPhone || '',
                        nation: info.userUnit || '',
                        gender: String(info.userUnitLevel) || '',
                        workPhone: info.userDept || '',
                        work_title: info.userZhiwu || '',
                        grade: String(info.userZhicheng) || '',
                        userEmail: info.userEmail || '',
                        pf_work: info.userArea || info.userUnit || ''
                    };
                    
                    // 如果有地区信息，转换为级联选择器的值
                    if (info.userRegion && info.userRegion.length > 0) {
                        this.SetGeRenData.region = info.userRegion;
                        this.SetGeRenData.selectedRegionLabels = [...info.userRegion];
                        this.manuallySetCascaderValue(info.userRegion);
                    } else if (info.userArea) {
                        const areas = info.userArea.split(' ');
                        if (areas.length > 0) {
                            this.SetGeRenData.region = areas;
                            this.SetGeRenData.selectedRegionLabels = [...areas];
                            this.manuallySetCascaderValue(areas);
                        }
                    }
                    
                    // 处理address字段（如果存在）
                    if (info.address) {
                        
                        try {
                            // 尝试解析address字段
                            if (info.address.includes(' ')) {
                                // 如果address包含空格，可能是省市区格式
                                const addressParts = info.address.split(' ');
                                if (addressParts.length > 0) {
                                    this.SetGeRenData.region = addressParts;
                                    this.SetGeRenData.selectedRegionLabels = [...addressParts];
                                    this.SetGeRenData.pf_work = info.address;
                                    this.manuallySetCascaderValue(addressParts);
                                }
                            } else {
                                // 如果address是编码格式，需特殊处理
                                // 将address值保存到region，显示时会尝试匹配
                                this.SetGeRenData.region = [info.address];
                                // 同时设置pf_work以确保提交时有值
                                this.SetGeRenData.pf_work = info.address;
                            }
                        } catch (error) {
                            console.error('解析address字段失败:', error);
                        }
                    }
                    
                    return; // 编辑模式下不需要从localStorage恢复
                }
            }
            
            // 获取前面页面填写的数据
            const formData = this.formData && this.formData();
            
            // 尝试从 localStorage 恢复数据
            try {
                const savedBasicInfo = localStorage.getItem('basicInfoData');
                if (savedBasicInfo) {
                    const basicInfo = JSON.parse(savedBasicInfo);
                    
                    // 填充基本信息表单
                    this.SetGeRenData = {
                        ...this.SetGeRenData,
                        name: basicInfo.userName || '',
                        mobile: basicInfo.userPhone || '',
                        nation: basicInfo.userUnit || '',
                        gender: basicInfo.userUnitLevel || '',
                        workPhone: basicInfo.userDept || '',
                        work_title: basicInfo.userZhiwu || '',
                        grade: basicInfo.userZhicheng || '',
                        userEmail: basicInfo.userEmail || '', 
                        pf_work: basicInfo.userArea || ''
                    };
                    
                    // 如果有地区信息，转换为级联选择器的值
                    if (basicInfo.userRegion && basicInfo.userRegion.length > 0) {
                        this.SetGeRenData.region = basicInfo.userRegion;
                        this.SetGeRenData.selectedRegionLabels = [...basicInfo.userRegion];
                        this.manuallySetCascaderValue(basicInfo.userRegion);
                    } else if (basicInfo.userArea) {
                        const areas = basicInfo.userArea.split(' ');
                        if (areas.length > 0) {
                            this.SetGeRenData.region = areas;
                            this.SetGeRenData.selectedRegionLabels = [...areas];
                            this.manuallySetCascaderValue(areas);
                        }
                    }
                    
                } else if (formData && formData.basicInfo) {
                    this.SetGeRenData = {
                        ...this.SetGeRenData,
                        name: formData.basicInfo.userName || '',
                        mobile: formData.basicInfo.userPhone || '',
                        nation: formData.basicInfo.userUnit || '',
                        gender: formData.basicInfo.userUnitLevel || '',
                        workPhone: formData.basicInfo.userDept || '',
                        work_title: formData.basicInfo.userZhiwu || '',
                        grade: formData.basicInfo.userZhicheng || '',
                        userEmail: formData.basicInfo.userEmail || '',
                        pf_work: formData.basicInfo.userArea || ''
                    };
                    
                    // 如果有地区信息，转换为级联选择器的值
                    if (formData.basicInfo.userRegion && formData.basicInfo.userRegion.length > 0) {
                        this.SetGeRenData.region = formData.basicInfo.userRegion;
                        this.SetGeRenData.selectedRegionLabels = [...formData.basicInfo.userRegion];
                        this.manuallySetCascaderValue(formData.basicInfo.userRegion);
                    } else if (formData.basicInfo.userArea) {
                        const areas = formData.basicInfo.userArea.split(' ');
                        if (areas.length > 0) {
                            this.SetGeRenData.region = areas;
                            this.SetGeRenData.selectedRegionLabels = [...areas];
                            this.manuallySetCascaderValue(areas);
                        }
                    }
                } else if (!this.isDraftMode) {
                    // 只有在没有保存的数据且非草稿模式下才调用获取用户信息
                    this.getUserInfo();
                }
            } catch (error) {
                console.error('解析localStorage数据失败:', error);
                // 失败时尝试使用formData
                if (formData && formData.basicInfo) {
                    this.SetGeRenData = {
                        ...this.SetGeRenData,
                        name: formData.basicInfo.userName || '',
                        mobile: formData.basicInfo.userPhone || '',
                        nation: formData.basicInfo.userUnit || '',
                        gender: formData.basicInfo.userUnitLevel || '',
                        workPhone: formData.basicInfo.userDept || '',
                        work_title: formData.basicInfo.userZhiwu || '',
                        grade: formData.basicInfo.userZhicheng || '',
                        userEmail: formData.basicInfo.userEmail || '',
                        pf_work: formData.basicInfo.userArea || ''
                    };
                    
                    // 如果有地区信息，转换为级联选择器的值
                    if (formData.basicInfo.userRegion && formData.basicInfo.userRegion.length > 0) {
                        this.SetGeRenData.region = formData.basicInfo.userRegion;
                        this.SetGeRenData.selectedRegionLabels = [...formData.basicInfo.userRegion];
                        this.manuallySetCascaderValue(formData.basicInfo.userRegion);
                    } else if (formData.basicInfo.userArea) {
                        const areas = formData.basicInfo.userArea.split(' ');
                        if (areas.length > 0) {
                            this.SetGeRenData.region = areas;
                            this.SetGeRenData.selectedRegionLabels = [...areas];
                            this.manuallySetCascaderValue(areas);
                        }
                    }
                } else if (!this.isDraftMode) {
                    // 只有在非草稿模式下才调用获取用户信息
                    this.getUserInfo();
                }
            }
        },
        methods: {
            // 新增方法：更新级联选择器的显示
            updateCascaderDisplay(regionNames) {
                if (!regionNames || regionNames.length === 0) return;
                
                // 检查是否是三级地区且都是汉字
                if (regionNames.length !== 3 || !regionNames.every(item => /^[\u4e00-\u9fa5]+$/.test(item))) {
                    this.$message.warning("地区格式不正确，请重新选择完整的省、市、区/县三级地区");
                    // 清空选择
                    this.SetGeRenData.region = [];
                    this.SetGeRenData.pf_work = '';
                    this.SetGeRenData.selectedRegionLabels = [];
                    
                    // 清空级联选择器的显示
                    setTimeout(() => {
                        const cascaderEls = document.querySelectorAll('.el-cascader__label');
                        if (cascaderEls && cascaderEls.length > 0) {
                            for (let el of cascaderEls) {
                                el.textContent = '';
                            }
                        }
                        
                        const cascaderInput = document.querySelector('.el-cascader .el-input__inner');
                        if (cascaderInput) {
                            cascaderInput.value = '';
                        }
                    }, 100);
                    
                    return;
                }
                
                // 先将汉字区域名称转为省市区代码值
                this.findRegionCodesByNames(regionNames).then(regionCodes => {
                    if (regionCodes && regionCodes.length > 0) {
                        // 设置级联选择器的值为地区代码，这样选择器才能正确显示
                        this.$nextTick(() => {
                            // 使用新的代码值更新级联选择器
                            this.SetGeRenData.region = regionCodes;
                        });
                    } else {
                        // 如果无法找到代码，则尝试直接显示文本
                        this.$nextTick(() => {
                            // 直接更新级联选择器的显示文本
                            const cascaderInput = document.querySelector('.el-cascader .el-input__inner');
                            if (cascaderInput) {
                                cascaderInput.value = regionNames.join(' ');
                            }
                        });
                    }
                });
            },
            
            // 新增方法：根据地区名称查找对应的代码值
            findRegionCodesByNames(regionNames) {
                return new Promise(resolve => {
                    try {
                        if (regionNames.length !== 3) {
                            // 如果地区名称不是三级，直接返回空数组
                            resolve([]);
                            return;
                        }
                        
                        // 确保所有名称都是汉字
                        if (!regionNames.every(item => /^[\u4e00-\u9fa5]+$/.test(item))) {
                            resolve([]);
                            return;
                        }
                        
                        const provinceName = regionNames[0];
                        const cityName = regionNames[1];
                        const countyName = regionNames[2];
                        
                        // 查找省级代码
                        const provinceOption = this.regionOptions.find(option => 
                            option.label === provinceName || 
                            option.label.includes(provinceName) || 
                            provinceName.includes(option.label)
                        );
                        
                        if (!provinceOption) {
                            console.error('未找到匹配的省份:', provinceName);
                            resolve([]);
                            return;
                        }
                        
                        // 查找市级代码
                        const cityOption = provinceOption.children.find(option => 
                            option.label === cityName || 
                            option.label.includes(cityName) || 
                            cityName.includes(option.label)
                        );
                        
                        if (!cityOption) {
                            console.error('未找到匹配的城市:', cityName);
                            resolve([]);
                            return;
                        }
                        
                        // 查找区/县级代码
                        const countyOption = cityOption.children.find(option => 
                            option.label === countyName || 
                            option.label.includes(countyName) || 
                            countyName.includes(option.label)
                        );
                        
                        if (!countyOption) {
                            console.error('未找到匹配的区/县:', countyName);
                            resolve([]);
                            return;
                        }
                        
                        // 找到完整路径
                        const result = [provinceOption.value, cityOption.value, countyOption.value];
                        
                        // 打印调试信息
                        
                        resolve(result);
                    } catch (error) {
                        console.error('查找地区代码失败:', error);
                        resolve([]);
                    }
                });
            },
            
            // 省市区数据已使用element-china-area-data提供的数据，不需要loadRegionData方法
            
            // 处理地区选择变化
            handleRegionChange(value) {
                if (value && value.length > 0) {
                    // 从级联选择器获取汉字形式的省市区名称
                    try {
                        // 获取选中项的完整路径（包含标签文本）
                        const regionLabels = [];
                        let options = this.regionOptions;
                        
                        // 遍历每一级的值，找到对应的标签文本
                        for (let i = 0; i < value.length; i++) {
                            const currentValue = value[i];
                            const currentOption = options.find(opt => opt.value === currentValue);
                            
                            if (currentOption) {
                                regionLabels.push(currentOption.label);
                                options = currentOption.children || [];
                            }
                        }
                        
                        // 检查是否选择了三级地区（省市区/县）
                        if (regionLabels.length < 3) {
                            this.$message.warning("请选择完整的省、市、区/县三级地区");
                            // 清空选择
                            this.SetGeRenData.region = [];
                            return;
                        }
                        
                        // 检查是否所有值都是汉字
                        const allChinese = regionLabels.every(item => /^[\u4e00-\u9fa5]+$/.test(item));
                        if (!allChinese) {
                            this.$message.warning("地区格式不正确，请重新选择");
                            // 清空选择
                            this.SetGeRenData.region = [];
                            return;
                        }
                        
                        // 将选择的省市区汉字名称组合为字符串存入pf_work字段
                        this.SetGeRenData.pf_work = regionLabels.join(' ');
                        
                        // 保存汉字名称到selectedRegionLabels字段，用于数据提交
                        this.SetGeRenData.selectedRegionLabels = regionLabels;
                        
                        // 同时保存代码值，用于选择器显示
                        this.SetGeRenData.region = value;
                    } catch (error) {
                        console.error('获取地区名称失败:', error);
                        // 如果出错，则使用原始值
                        this.SetGeRenData.pf_work = value.join(' ');
                    }
                } else {
                    this.SetGeRenData.pf_work = '';
                    this.SetGeRenData.selectedRegionLabels = [];
                }
            },
            
            // 根据已有的地区代码尝试匹配并选择对应的省市区
            initRegionFromCode() {
                // 如果有地区代码但没有可读的地区名称，尝试从区域数据中匹配
                if (this.SetGeRenData.region && this.SetGeRenData.region.length > 0) {
                    const regionCode = this.SetGeRenData.region[0];
                    
                    // 如果是纯数字格式（可能是地区代码）
                    if (/^[0-9 ]+$/.test(regionCode)) {
                        // 如果是数字代码格式，需要清空并提示用户重新选择
                        this.$message.warning("地区格式不正确，请重新选择完整的省、市、区/县三级地区");
                        // 清空选择
                        this.SetGeRenData.region = [];
                        this.SetGeRenData.pf_work = '';
                        this.SetGeRenData.selectedRegionLabels = [];
                        
                        // 清空级联选择器的显示
                        setTimeout(() => {
                            const cascaderEls = document.querySelectorAll('.el-cascader__label');
                            if (cascaderEls && cascaderEls.length > 0) {
                                for (let el of cascaderEls) {
                                    el.textContent = '';
                                }
                            }
                            
                            const cascaderInput = document.querySelector('.el-cascader .el-input__inner');
                            if (cascaderInput) {
                                cascaderInput.value = '';
                            }
                        }, 100);
                    }
                }
                
                // 检查pf_work是否符合要求
                if (this.SetGeRenData.pf_work) {
                    const regions = this.SetGeRenData.pf_work.split(' ');
                    // 必须是三级地区且都是汉字
                    if (!(regions.length === 3 && regions.every(item => /^[\u4e00-\u9fa5]+$/.test(item)))) {
                        this.$message.warning("地区格式不正确，请重新选择完整的省、市、区/县三级地区");
                        // 清空选择
                        this.SetGeRenData.region = [];
                        this.SetGeRenData.pf_work = '';
                        this.SetGeRenData.selectedRegionLabels = [];
                    }
                }
            },
            
            // 检测设备类型
            checkDeviceType() {
                this.isMobile = window.innerWidth <= 768;
            },
            checkLoginStatus() {
                const status = checkTokenExpiration();
                if (status.expired) {
                    clearLoginInfo(); // 清除登录信息
                    this.$confirm(status.message, '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        // 用户点击取消，也跳转到首页
                        this.$router.push('/');
                    });
                    return false;
                }
                return true;
            },
            getLocalData(i){
                this.TypeId = i;
                var InfoData = JSON.parse(localStorage.getItem("InfoData"));
                this.Id = InfoData && InfoData.id || '';
                this.SetData={
                    City:[parseInt(InfoData && InfoData.province || ''),parseInt(InfoData && InfoData.city || '')],
                    synopsis:InfoData && InfoData.synopsis,
                    address:InfoData && InfoData.address,
                    name:InfoData && InfoData.name,
                };
                if(i==1){
                    this.SetGeRenData ={
                        gender:InfoData && InfoData.gender,
                        mobile:InfoData && InfoData.mobile,
                        is_public:InfoData && InfoData.is_public,
                        work_mobile:InfoData && InfoData.work_mobile,
                        native_place:InfoData && InfoData.native_place.split("-"),
                        nation:InfoData && InfoData.nation,
                        userEmail:InfoData && InfoData.userEmail,
                        political_party:InfoData && InfoData.political_party,
                        degree:InfoData && InfoData.degree,
                        qualification:InfoData && InfoData.qualification,
                        major:InfoData && InfoData.major,
                        work_title:InfoData && InfoData.work_title,
                        pf_work:InfoData && InfoData.pf_work,
                        workPhone:InfoData && InfoData.workPhone,
                        birthday:InfoData && InfoData.birthday,
                        marriage:InfoData && InfoData.marriage,
                        religion:InfoData && InfoData.religion,
                    }
                }
                if(i==2){
                    this.SetGongSiData ={
                        legal_person:InfoData && InfoData.legal_person,
                        legal_license:InfoData && InfoData.legal_license,
                        link_name:InfoData && InfoData.link_name,
                        link_mobile:InfoData && InfoData.link_mobile,
                        link_email:InfoData && InfoData.link_email,
                        institutions:InfoData && InfoData.institutions,
                        business_field:InfoData && InfoData.business_field,
                        mechanism_website:InfoData && InfoData.mechanism_website,
                        mechanism_wnumber:InfoData && InfoData.mechanism_wnumber,
                        social_institution:InfoData && InfoData.social_institution,
                    }
                }
            },
            ToggleStep() {
                if(this.ConfigDisabled) return;
                
                // 表单验证
                if(!this.SetGeRenData.name){
                    this.$message.warning("请输入姓名");
                    return;
                }
                if(!this.SetGeRenData.mobile){
                    this.$message.warning("请输入手机号");
                    return;
                }
                if(!this.SetGeRenData.nation){
                    this.$message.warning("请输入单位名称");
                    return;
                }
                if(!this.SetGeRenData.gender){
                    this.$message.warning("请选择单位等级");
                    return;
                }
                
                // 检查地区信息格式
                let isValidRegion = false;
                let regionText = '';
                
                // 检查是否有选择地区且格式正确
                if (this.SetGeRenData.selectedRegionLabels && this.SetGeRenData.selectedRegionLabels.length === 3) {
                    // 检查是否都是汉字格式
                    const allChinese = this.SetGeRenData.selectedRegionLabels.every(item => /^[\u4e00-\u9fa5]+$/.test(item));
                    if (allChinese) {
                        isValidRegion = true;
                        regionText = this.SetGeRenData.selectedRegionLabels.join(' ');
                    }
                } 
                // 从pf_work中检查格式
                else if (this.SetGeRenData.pf_work) {
                    const regions = this.SetGeRenData.pf_work.split(' ');
                    // 必须是三级地区且都是汉字
                    if (regions.length === 3 && regions.every(item => /^[\u4e00-\u9fa5]+$/.test(item))) {
                        isValidRegion = true;
                        regionText = this.SetGeRenData.pf_work;
                    }
                }
                
                // 如果地区格式不正确，提示重新填写
                if (!isValidRegion) {
                    this.$message.warning("请重新填写地区，格式应为\"省 市 县/区\"");
                    return;
                }
                
                if(!this.SetGeRenData.workPhone){
                    this.$message.warning("请输入科室/部门");
                    return;
                }
                if(!this.SetGeRenData.work_title){
                    this.$message.warning("请输入职务");
                    return;
                }
                if(!this.SetGeRenData.grade){
                    this.$message.warning("请选择职称");
                    return;
                }
                if(!this.SetGeRenData.userEmail){
                    this.$message.warning("请输入邮箱账号");
                    return;
                }

                // 传递完整的表单数据（确保使用地区汉字名称）
                const formData = {
                    userName: this.SetGeRenData.name,
                    userPhone: this.SetGeRenData.mobile,
                    userUnit: this.SetGeRenData.nation,
                    userUnitLevel: this.SetGeRenData.gender,
                    userDept: this.SetGeRenData.workPhone,
                    userZhiwu: this.SetGeRenData.work_title,
                    userZhicheng: this.SetGeRenData.grade,
                    userEmail: this.SetGeRenData.userEmail,
                    userArea: regionText,
                    address: regionText, // 确保address字段有值
                    userRegion: this.SetGeRenData.selectedRegionLabels || []
                };


                // 保存到 localStorage，使用一个额外的时间戳标记，防止数据过期
                const dataToSave = {
                    ...formData,
                    _timestamp: new Date().getTime() // 添加时间戳
                };
                
                localStorage.setItem('basicInfoData', JSON.stringify(dataToSave));
                
                // 发送数据到父组件
                this.$emit("PageBtn", "next", formData);
            },
            // 添加邮箱验证方法
            validateEmail(email) {
                const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                return reg.test(email);
            },
            UpFile({ file,data}) {
                var isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
                if (!isJPG) {
                  this.$message.error('营业执照只能是 JPG/PNG 格式');
                  return false;
                }else{
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$Global.FileUpData(fd,(res)=>{
                        this.SetGongSiData.legal_license = res.data.url;
                        this.$forceUpdate();
                    })
                }
            },
            // 获取单位等级列表
            getHosLevelList() {
                if (!this.checkLoginStatus()) return;
                this.$get('/api/v1/works/getHosLevel').then(res => {
                    if (res.data.code === 200) {
                        this.hosLevelList = res.data.data.filter(item => item.status === '0') || [];
                    } else {
                        this.$message.error(res.data.msg || '获取单位等级列表失败');
                    }
                }).catch(err => {
                    this.$message.error('获取单位等级列表失败');
                });
            },
            // 获取职称列表
            getZhichengList() {
                if (!this.checkLoginStatus()) return;
                this.$get('/api/v1/works/getZhicheng').then(res => {
                    if (res.data.code === 200) {
                        this.zhichengList = res.data.data || [];
                    } else {
                        this.$message.error(res.data.msg || '获取职称列表失败');
                    }
                }).catch(err => {
                    this.$message.error('获取职称列表失败');
                });
            },
            // 获取用户上一次提交的作品信息
            getLastSubmittedInfo() {
                // 如果是草稿模式或编辑模式，不需要获取上一次提交信息
                if (this.isDraftMode || (this.isEdit && this.isEdit())) {
                    return Promise.resolve(null);
                }
                
                // 使用作品列表接口，设置较大的pageSize并添加排序参数
                const params = {
                    pageNum: 1,
                    pageSize: 100, // 使用较大的页面大小
                    orderByColumn: 'createTime', // 按创建时间排序
                    isAsc: 'desc' // 降序排列，最新的在前面
                };
                
                return this.$get('/api/v1/works/workslist', params).then(res => {
                    if (res.data.code === 200 && res.data.rows && res.data.rows.length > 0) {
                        // 获取最新的作品ID（应该是第一条）
                        const lastWorkId = res.data.rows[0].id;
                        
                        // 获取作品详情
                        return this.$get(`/api/v1/works/workinfo/${lastWorkId}`).then(detailRes => {
                            if (detailRes.data.code === 200 && detailRes.data.data) {
                                this.lastSubmittedInfo = detailRes.data.data;
                                
                                // 填充表单数据
                                this.SetGeRenData = {
                                    ...this.SetGeRenData,
                                    name: this.lastSubmittedInfo.userName || this.SetGeRenData.name,
                                    mobile: this.lastSubmittedInfo.userPhone || this.SetGeRenData.mobile,
                                    nation: this.lastSubmittedInfo.userUnit || this.SetGeRenData.nation,
                                    gender: String(this.lastSubmittedInfo.userUnitLevel) || this.SetGeRenData.gender,
                                    workPhone: this.lastSubmittedInfo.userDept || this.SetGeRenData.workPhone,
                                    work_title: this.lastSubmittedInfo.userZhiwu || this.SetGeRenData.work_title,
                                    grade: String(this.lastSubmittedInfo.userZhicheng) || this.SetGeRenData.grade,
                                    userEmail: this.lastSubmittedInfo.userEmail || this.SetGeRenData.userEmail,
                                    pf_work: this.lastSubmittedInfo.userArea || this.lastSubmittedInfo.address || this.SetGeRenData.pf_work
                                };
                                
                                // 处理地区信息
                                if (this.lastSubmittedInfo.userRegion && this.lastSubmittedInfo.userRegion.length > 0) {
                                    this.SetGeRenData.region = this.lastSubmittedInfo.userRegion;
                                    this.SetGeRenData.selectedRegionLabels = [...this.lastSubmittedInfo.userRegion];
                                    this.manuallySetCascaderValue(this.lastSubmittedInfo.userRegion);
                                } else if (this.lastSubmittedInfo.address) {
                                    const areas = this.lastSubmittedInfo.address.split(' ');
                                    if (areas.length > 0) {
                                        this.SetGeRenData.region = areas;
                                        this.SetGeRenData.selectedRegionLabels = [...areas];
                                        this.manuallySetCascaderValue(areas);
                                    }
                                } else if (this.lastSubmittedInfo.userArea) {
                                    const areas = this.lastSubmittedInfo.userArea.split(' ');
                                    if (areas.length > 0) {
                                        this.SetGeRenData.region = areas;
                                        this.SetGeRenData.selectedRegionLabels = [...areas];
                                        this.manuallySetCascaderValue(areas);
                                    }
                                }
                                
                                return this.lastSubmittedInfo;
                            } else {
                                return null;
                            }
                        }).catch(err => {
                            console.error('获取作品详情失败:', err);
                            return null;
                        });
                    } else {
                        return null;
                    }
                }).catch(err => {
                    console.error('获取作品列表失败:', err);
                    return null;
                });
            },
            // 获取用户信息
            getUserInfo() {
                // 如果是草稿模式，不调用接口
                if (this.isDraftMode) {
                    return;
                }
                
                // 先尝试获取上一次提交的作品信息
                this.getLastSubmittedInfo().then(lastInfo => {
                    // 如果没有上一次提交的信息，才获取用户基本信息
                    if (!lastInfo) {
                        this.$get('/getInfo').then(res => {
                            if (res.data.code === 200) {
                                const userInfo = res.data.user;
                                // 设置基本表单数据
                                this.SetGeRenData = {
                                    ...this.SetGeRenData,
                                    name: userInfo.nickName || userInfo.userName || '',
                                    mobile: userInfo.phonenumber || '',
                                    userEmail: userInfo.email || '',
                                    nation: userInfo.hospitalName || '', // 将hospitalName映射到单位名称字段
                                };
                            }
                        }).catch(err => {
                            console.error('登录失效，请重新登录:', err);
                        });
                    }
                });
            },
            // 查询医院/单位名称
            queryHospitals(queryString, cb) {
                if (!this.checkLoginStatus()) return;
                
                // 如果查询字符串为空，不进行搜索
                if (queryString.trim() === '') {
                    cb([]);
                    return;
                }
                
                // 不再从缓存中过滤，每次输入变化都直接调用接口
                // 首次查询或hospitalList为空，从API获取数据
                this.$get(`/api/v1/works/hoslist/?name=${queryString}`).then(res => {
                    if (res.data.code === 200) {
                        // 将API返回的医院列表转换为自动完成所需的格式
                        const hospitals = res.data.data.map(hospital => {
                            return {
                                value: hospital.name || '', // 使用name作为显示值
                                hospitalId: hospital.id,
                                hospitalLevel: hospital.level || ''
                            };
                        });
                        
                        // 返回结果
                        cb(hospitals);
                    } else {
                        this.$message.error(res.data.msg || '获取单位列表失败');
                        cb([]);
                    }
                }).catch(err => {
                    console.error('获取单位列表失败:', err);
                    this.$message.error('获取单位列表失败，请重试');
                    cb([]);
                });
            },
            
            // 处理医院选择
            handleHospitalSelect(item) {
                this.SetGeRenData.nation = item.value;
                
                // 如果选中的医院有等级信息，自动填充单位等级
                if (item.hospitalLevel) {
                    this.SetGeRenData.gender = String(item.hospitalLevel);
                }
            },
            
            manuallySetCascaderValue(regionNames) {
                if (!regionNames || regionNames.length === 0) return;
                
                // 检查是否是三级地区且都是汉字
                if (regionNames.length !== 3 || !regionNames.every(item => /^[\u4e00-\u9fa5]+$/.test(item))) {
                    this.$message.warning("地区格式不正确，请重新选择完整的省、市、区/县三级地区");
                    // 清空选择
                    this.SetGeRenData.region = [];
                    this.SetGeRenData.pf_work = '';
                    this.SetGeRenData.selectedRegionLabels = [];
                    
                    // 清空级联选择器的显示
                    setTimeout(() => {
                        const cascaderEls = document.querySelectorAll('.el-cascader__label');
                        if (cascaderEls && cascaderEls.length > 0) {
                            for (let el of cascaderEls) {
                                el.textContent = '';
                            }
                        }
                        
                        const cascaderInput = document.querySelector('.el-cascader .el-input__inner');
                        if (cascaderInput) {
                            cascaderInput.value = '';
                        }
                    }, 100);
                    
                    return;
                }
                
                // 存储省市区显示值
                this.SetGeRenData.pf_work = regionNames.join(' ');
                
                // 先尝试通过findRegionCodesByNames方法找到代码值
                this.findRegionCodesByNames(regionNames).then(regionCodes => {
                    if (regionCodes && regionCodes.length === 3) {
                        // 设置级联选择器的值为地区代码，这样选择器才能正确显示
                        this.$nextTick(() => {
                            // 使用新的代码值更新级联选择器
                            this.SetGeRenData.region = regionCodes;
                        });
                    } else {
                        // 如果无法找到代码，直接手动修改DOM显示正确的地区文本
                        this.$nextTick(() => {
                            // 获取所有级联选择器组件
                            const cascaders = document.querySelectorAll('.el-cascader');
                            
                            cascaders.forEach(cascader => {
                                // 找到输入框
                                const input = cascader.querySelector('.el-input__inner');
                                if (input) {
                                    // 直接设置显示文本
                                    input.value = regionNames.join(' ');
                                    
                                    // 触发change事件以通知Vue更新数据
                                    const event = new Event('change', { bubbles: true });
                                    input.dispatchEvent(event);
                                }
                                
                                // 找到级联选择器标签
                                const label = cascader.querySelector('.el-cascader__label');
                                if (label) {
                                    label.textContent = regionNames.join(' ');
                                }
                            });
                        });
                    }
                });
            }
        },
        watch: {
            Type: function (val) {
                this.TypeId = val;
                if(val != 1) {
                    this.SetData = {
                        City:[],
                        synopsis:"",
                        address:"",
                        name:"",
                    };
                }
            },
            worksInfo: {
                immediate: true,
                handler(newVal) {
                    if (this.isEdit && this.isEdit() && newVal) {
                        const info = this.worksInfo();
                        if (info) {
                            
                            // 在编辑模式下更新数据，确保字段名称一致
                            this.SetGeRenData = {
                                ...this.SetGeRenData, // 保留现有数据
                                name: info.userName || '',
                                mobile: info.userPhone || '',
                                nation: info.userUnit || '',
                                gender: String(info.userUnitLevel) || '',
                                workPhone: info.userDept || '',
                                work_title: info.userZhiwu || '',
                                grade: String(info.userZhicheng) || '',
                                userEmail: info.userEmail || '',
                                pf_work: info.userArea || info.userUnit || '',
                            };
                        }
                    }
                }
            }
        },
    }
</script>
<style>
    /* 默认隐藏移动端元素 */
    .mobile-only {
        display: none;
    }
    
    /* PC端默认显示 */
    .pc-only {
        display: block;
    }
    
    /* 移动端样式 */
    @media only screen and (max-width: 768px) {
        .pc-only {
            display: none !important;
        }
        .mobile-only {
            display: block !important;
        }
    }
</style>
<style scoped>
    /* PC端样式 */
    .MarTop {
        margin-top: 20px;
    }
    .Steps{
        display: none;
        align-items: center;
        margin: 30px 0;
        display: none;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
    }
    .StepJiBen{
        margin:0 auto;
        width: 60%;
    }
    .StepJiBenItem{
        display: flex;
        margin-bottom: 20px;
    }
    .StepJiBenItemTit{
        width: 240px;
        text-align: right;
        margin-right: 20px;
    }
    .StepJiBenItemTit .Icon{
        color: #ff0000;
        font-weight: 400;
        font-size: 20px;
        margin-right: 5px;
    }
    .StepJiBenItemTit .Tit{
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .StepJiBenItemVal{
        flex: 1;
    }
    .StepJiBenItemVal .WidMax{
        width: 100%;
    }
    .StepJiBenItemVal.DisFlex{
        display: flex;
    }
    .StepCommFileBtn{
        padding: 3px 35px;
        background: #F5F5F5;
        border-radius: 5px;
        border: 1px solid #CCCCCC;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        margin-left: 20px;
    }
    .StepCommFileMsg{
        font-weight: 400;
        font-size: 18px;
        color: #999999;
    }
    .StepCommFileLock{
        font-size: 16px;
        color: #0385EB;
        padding: 0 10px;
    }
    .StepCommFileImg{
        border: 1px solid #ddd;
        padding: 2px;
        cursor: pointer;
        margin-left: 5px;
    }
    .StepCommFileImg img{
        width: 50px;
        height: 50px;
    }
    .StepBtns{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:  30px 0
    }
    .StepBtn{
        margin-right: 20px;
        width: 120px;
        text-align: center;
        padding: 7px 15px;
        color: #fff;
        font-size: 18px;
        background: #58C1B6;
        border-radius: 20px;
        cursor: pointer;
    }
    .StepBtn.StpepDisabled{
        background: #a8d3cf;
        cursor: no-drop;
    }
    .Table {
        width: 99%;
        margin: 10px auto;
        border-radius: 5px;
        border-collapse: collapse;
    }
    .Table td {
        border: 1px solid #e4eaec;
        padding: 10px;
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .Table .State{
        padding-right: 10px;
    }
    .Table .Th {
        color: #000000;
        font-size: 16px;
        padding: 10px;
        font-weight: 700;
    }
    
    .Table td .Red {
        color: #d51938;
        font-weight: 700;
        vertical-align: middle;
    }
    .Red {
        color: #d51938;
        font-weight: 700;
        vertical-align: middle;
    }
    .Table .TableDis {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .WidMax{
        width: 100%;
    }
    
    /* 移动端样式 */
    .mobile-form {
        margin: 15px 0;
    }
    
    .form-item {
        margin-bottom: 15px;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 15px;
    }
    
    .form-label {
        font-size: 14px;
        color: #333;
        margin-bottom: 8px;
        font-weight: bold;
    }
    
    .form-input {
        width: 100%;
    }
    
    .form-input .el-input {
        width: 100%;
    }
    
    .radio-group {
        display: flex;
        flex-direction: column;
    }
    
    .mobile-radio {
        margin-right: 0 !important;
        margin-bottom: 10px;
    }
    
    .mobile-radio .el-radio__label {
        font-size: 14px;
    }
    
    .info-save {
        color: red;
        font-weight: bold;
        margin: 15px 0;
        font-size: 14px;
        text-align: center;
    }
    
    @media only screen and (max-width: 768px) {
        .StepBtn {
            width: 100px;
            font-size: 16px;
            padding: 7px 12px;
        }
        
        .StepBtns {
            margin: 20px 0;
        }
    }
    
    /* 单选框相关样式 */
    :deep(.el-radio__input.is-checked .el-radio__inner) {
        background-color: #58C1B6;
        border-color: #58C1B6;
    }
    
    :deep(.el-radio__input.is-checked + .el-radio__label) {
        color: #58C1B6;
    }
    
    :deep(.el-radio__inner:hover) {
        border-color: #58C1B6;
    }
</style>